import { useMutation, useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom';
import { useGoToNotificationTileDetailsPage } from 'routes/navigators';
import { queryKeys } from 'services/constants';
import { Callback } from 'types/helpers';
import { errorHandler } from 'utils/errorHandler';
import { createNotificationTile } from 'services/notificationTiles/requests';
import { CreateNotificationTileFields } from 'pages/ProgramDetails/programTabComponents/Content/ContentTabComponents/NotificationTiles/types';
import { toNotificationTileDTO } from './mappers';

export const useCreateNotificationTile = (onSuccess?: Callback) => {
  const queryClient = useQueryClient();
  const { programId = '' } = useParams();

  const goToNotificationTileDetailsPage = useGoToNotificationTileDetailsPage();

  const { mutate, isLoading } = useMutation(createNotificationTile, {
    mutationKey: queryKeys.createNotificationTile,
    onSuccess: async (res) => {
      await queryClient.invalidateQueries(queryKeys.getNotificationTiles);
      onSuccess?.();
      goToNotificationTileDetailsPage(res.id);
    },
    onError: errorHandler,
  });

  return {
    isLoading,
    createNotificationTile: (notificationTile: CreateNotificationTileFields) =>
      mutate(
        toNotificationTileDTO({
          ...notificationTile,
          manufactureProgramUuid: programId,
        })
      ),
  };
};
